import { login } from "../../../services/authService";
import { redirectTo } from "../../../utils/httpHelper";

export default async function (baseUrl, tenantId, cb) {
  const { email, username, password } = cb._data;

  const urlParams = new URLSearchParams(window.location.search);
  const allowedKeys = ["deviceType", "deviceId", "ip", "timestamp"];
  const rawParams = Object.fromEntries(
    [...urlParams.entries()].filter(([key]) => allowedKeys.includes(key))
  );

  // Rename keys as needed
  const queryParams = {
    ...(rawParams.deviceType && { device_name: rawParams.deviceType }),
    ...(rawParams.deviceId && { device_id: rawParams.deviceId }),
    ...(rawParams.ip && { ip: rawParams.ip }),
    ...(rawParams.timestamp && { timestamp: rawParams.timestamp }),
  };

  const resJson = await login(baseUrl, { email, username, password, tenantId }, queryParams);

  if (resJson.status === "F") {
    cb.emit("submitDone", "");
    return;
  }
  cb.emit("submitDone", "");
  localStorage.setItem("loginToken", JSON.stringify(resJson.message));
  redirectTo();
}
